module.exports = __webpack_public_path__ + "static/During Work - 3-45d7a632329b2763d59bc32a343743ad.jpg";